import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { BoxT } from '@mentimeter/ragnar-ui/box';

/**
 * @deprecated This component is deprecated and will be removed in a future release.
 *
 * Narrow layout component that constrains content width to 800px.
 *
 * @remarks
 * This component is no longer maintained and may be removed in future releases.
 * Please migrate to alternative width constraint solutions from the design system.
 *
 * @param props - Props passed to the underlying Box component
 *
 * @returns A width-constrained Box component with max-width of 800px
 *
 * @warning
 * Do not use this component in new code. It will be deleted in the future.
 */
export const Narrow = (props: BoxT) => (
  <Box maxWidth="800px" width="100%" {...props} />
);
